import History from "../../@history/@history";

export const getDashboardData = async ({ userData, body, CurrentLanguage }) => {
    let responseData;
    let statusCode;
    let apiResponse;
    const language = CurrentLanguage ? CurrentLanguage : 'en'
    const requestOptions = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json',
            'apikey': userData.SecretKey,
            'Authorization': `Bearer ${userData.Token}`,
            'language': language
        }),
        body: JSON.stringify(body)
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}vioservice/dashboard`, requestOptions).then(async response => {
        responseData = response;
        apiResponse = await response.json()
        statusCode = response?.status;
        if (statusCode === 401 && apiResponse.message === 'Error verifying token : jwt expired') {
            localStorage.removeItem("userData")
            History.push('/login');
        }
    }).catch((error) => { return false }) 
    if (statusCode === 401) {
        localStorage.removeItem("userData")
        History.push('/login')
    }
    return apiResponse;
}

export const getDashboardDataByPagination = async ({userData,body,CurrentLanguage}) => {
    let statusCode;
    let apiResponse;
    const language = CurrentLanguage ? CurrentLanguage : "en"
    const requestOptions = {
        method:"POST",
        headers:new Headers({
            'Content-Type':'application/json',
            'apikey':userData?.SecretKey,
            'Authorization': `Bearer ${userData.Token}`,
            'language':language
        }),
        body: JSON.stringify(body)
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}vioservice/dashbaord/pagination`,requestOptions).then(async response => {
        apiResponse = await response.json();
        statusCode = response?.status; 
        if(statusCode === 401 || apiResponse.message === "Error verifying token : jwt expired"){
            localStorage.removeItem('userData')
            History.push("/login")
        }
    }).catch((error) => {return false})
    if(statusCode === 401){
        localStorage.removeItem("userData")
        History.push("/login")
    }
    return apiResponse;
}

export const exportData = async ({ userData, body }) => {
    let responseData;
    let apiResponse;
    let statusCode;
    const requestOptions = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json',
            'apikey': userData.SecretKey,
            'Authorization': `Bearer ${userData.Token}`
        }),
        body: JSON.stringify(body)
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}vioservice/export`, requestOptions).then(async response => {
        responseData = response;
        apiResponse = await response.json()
        statusCode = response?.status;
        if (statusCode === 401 && apiResponse.message === 'Error verifying token : jwt expired') {
            localStorage.removeItem("userData")
            History.push('/login');
        }
    }).catch((error) => {
        if (statusCode === 401) {
            localStorage.removeItem("userData")
            History.push('/login')
        }
        return false
    })
    if (apiResponse) return apiResponse;
}


